<template>
  <v-layout row justify-space-between>
    <v-flex>
      <div v-if="clientBusiness.locations" v-for="location in clientBusiness.locations">
        <div v-if="location.clients.length > 0" class="mb-3">
          <h3 class="headline">{{ location.name }}'s client users:</h3>
          <ul>
            <li class="subheading" v-for="client in location.clients">
              {{ client.name }} ({{ client.email }})
            </li>
          </ul>
        </div>
        <div v-else class="mb-2">
          <p class="body-1">No client users at {{ location.name }}...</p>
        </div>
      </div>
    </v-flex>
    <v-flex class="text-xs-right">
      <v-btn v-if="!addingClient" @click="addingClient = true" color='success'>
        <v-icon left>
          add
        </v-icon>
        Add Client User
      </v-btn>
      <v-layout column v-if="addingClient">
        <v-flex shrink>
          <v-select
            :items="clientBusiness.locations"
            item-text="name"
            item-value="id"
            label="Location"
            v-model="clientWorksiteId"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            label="First Name"
            v-model="clientFirstName"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            label="Last Name"
            v-model="clientLastName"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            label="Email (used for login)"
            v-model="clientEmail"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            :append-icon="showPass ? 'visibility' : 'visibility_off'"
            :type="showPass ? 'text' : 'password'"
            v-model="clientPassword"
            label="Password"
            @click:append="showPass = !showPass"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            :append-icon="showPassConfirm ? 'visibility' : 'visibility_off'"
            :type="showPassConfirm ? 'text' : 'password'"
            v-model="clientPasswordConfirm"
            label="Confirm Password"
            @click:append="showPassConfirm = !showPassConfirm"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn @click="addingClient = false" color='error'>
            Cancel
          </v-btn>
          <v-btn :disabled="!newClientValid" @click="createClient" color='success'>
            Create
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import collectionsApi from '@/api/collections'
import ApiField from '@/components/base/api-field.vue'
import clientApi from '@/api/client'

export default {
  props: [
    'clientBusiness'
  ],
  components: {
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    newClientValid: function () {
      if (
        this.clientFirstName &&
        this.clientLastName &&
        this.clientEmail &&
        this.clientPassword &&
        this.clientWorksiteId &&
        (this.clientPassword === this.clientPasswordConfirm)
      ) {
        return true
      }
      return false
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      possibleManagers: [],
      addingClient: false,
      clientWorksiteId: null,
      clientFirstName: '',
      clientLastName: '',
      clientEmail: '',
      clientPassword: '',
      clientPasswordConfirm: '',
      showPass: false,
      showPassConfirm: false,
    }
  },
  methods: {
    createClient () {
      clientApi.create({
        client: {
          worksite_id: this.clientWorksiteId,
          first_name: this.clientFirstName,
          last_name: this.clientLastName,
          email: this.clientEmail,
          password: this.clientPassword,
          password_confirmation: this.clientPasswordConfirm,
        }
      },
      res => {
        const message = `Created client ${ this.clientFirstName } ${ this.clientLastName }!`
        this.$store.dispatch('global/showSnackbarSuccess', { message: message })
        this.$store.dispatch('clientBusinesses/getClientBusiness', this.$route.params.clientBusinessId)
      },
        error => {
          const message = `Something went wrong creating that client...`
          this.$store.dispatch('global/showSnackbarError', { message: message })
      })
    },
    setUp () {
    },
    updateManager () {
      if (!this.newManager) {
        return
      }
      this.$store.dispatch('clientBusinesses/locationUpdate', {
        id: this.clientBusiness.locations[0].id,
        worksite: {
          manager_id: this.newManager.id
        }
      })
    },
  },
}
</script>

<style scoped>
</style>
